
const routes = [
	{
		path: "/",
		redirect: "/auth",
		component: () => import("@/layouts/Auth.vue"),
		children: [
			{
				path: "",
				redirect: "auth"
			},
			{
				path: "auth",
				name: "auth",
				component: () => import("@/views/Login.vue"),
				meta: {
					requiresRedirection: true,
					requiresAuth: false,
					title: "Login"
				}
			},
			{
				path: "auth/reset-password/:token",
				component: () => import("@/views/ResetPassword.vue"),
				meta: {
					requiresAuth: false,
					title: "Reset Password"
				}
			}
		]
	},
	{
		path: "/",
		component: () => import("@/layouts/Dashboard.vue"),
		children: [
		],
	},
	{
		// Share Campaign Analytics
		path: "/share/analytics/campaign/:campaignId",
		name: "shareCampaignAnalytics",
			component: () => import("@/views/CampaignAnalytics.vue"),
			props: { isShareAnalytics: true },
		meta: {
			requiresAuth: false,
			title: "Share Campaign Analytics"
		}
	},
	{
		// Share creative Analytics
		path: "/share/analytics/creative/:creativeId",
		name: "shareCreativeAnalytics",
			component: () => import("@/views/CreativeAnalytics.vue"),
			props: { isShareAnalytics: true },
		meta: {
			requiresAuth: false,
			title: "Share Creative Analytics"
		}
	},
	{
		// Share placement Analytics
		path: "/share/analytics/placement/:placementId",
		name: "sharePlacementAnalytics",
			component: () => import("@/views/PlacementAnalytics.vue"),
			props: { isShareAnalytics: true },
		meta: {
			requiresAuth: false,
			title: "Share Placement Analytics"
		}
	},


	{
		path: "/",
		component: () => import("@/layouts/DashboardLayout.vue"),
		children: [

			{
				// Shared with me
				path: "/shared-with-me",
				component: () => import("@/views/SharedWithMe.vue"),
				meta: {
					requiresAuth: true,
					title: "Shared with me"
				},
			},
			{
				// All Campaigns
				path: "/campaigns",
				component: () => import("@/views/Campaigns.vue"),
				meta: {
					requiresAuth: true,
					title: "Campaigns"
				},
			},

			{
				// Dashborad
				path: "/dashboard",
				alias: "/dashboard",
				name: "dashboard",
				component: () => import("@/views/Dashboard.vue"),
				meta: {
					requiresAuth: true,
					title: "Home"
				},
			},

			{
				// All Template
				path: "/alltemplates",
				component: () => import("@/views/TemplatePage.vue"),
				meta: {
					requiresAuth: true,
					title: "Templates"
				},
			},

			{
				// Reports
				path: "/reports",
				component: () => import("@/views/Reports.vue"),
				meta: {
					requiresAuth: true,
					title: "Reports"
				},
			},

			{
				path: "/generated-reports",
				redirect: "/reports",
			},
			{
				path: "/schedule-report",
				redirect: "/reports",
			},

			{
				path:"/shared-with-me",
				component: () => import('@/views/SharedWithMe.vue'),
				meta:{
					requiresAuth: true,
					title: "BrandKit"
				}
			},


			// brandkit Page
			{
				path:"/brand-kits",
				component: () => import('@/views/BrandKitNewPage.vue'),
				meta:{
					requiresAuth: true,
					title: "BrandKit"
				}
			},


			// brandkit Detailed page
			{
				path:"/brand-kits/:id",
				component: () => import('@/views/BrandkitDetailPageNew.vue'),
				meta:{
					requiresAuth: true,
					title: "Brandkit Details"
				}
			},

			// Folder Detailed page
			{
				path:"/brand-kits/:brandkitId/sub-folder/:folderId",
				component: () => import('@/views/BrandkitSubFolderDetail.vue'),
				meta:{
					requiresAuth: true,
					title: "BrandkitSubFolder"
				}
			},

			{
				path:"/brand-kits/folder/:folderId",
				component: () => import('@/views/FolderBrandKit.vue'),
				meta:{
					requiresAuth: true,
					title: "FolderBrandKit"
				}
			},

			{
				// Teams
				path: "/teams",
				component: () => import("@/views/TeamPage.vue"),
				meta: {
					requiresAuth: true,
					title: "Team"
				},
			},
			{
				// Profile
				path: "/profile",
				component: () => import("@/views/UserProfile.vue"),
				meta: {
					requiresAuth: true,
					title: "Profile"
				},
			},
			{
				// Trash
				path: "/trash",
				component: () => import("@/views/TrashPage.vue"),
				meta: {
					requiresAuth: true,
					title: "Trash"
				},
			},
			{
				// Creative Analytics
				path: "/analytics/creative/:creativeId",
				name: "creativeanalytics",
				component: () => import("@/views/CreativeAnalytics.vue"),
				props: true,
				meta: {
					requiresAuth: true,
					title: "Creative Analytics"
				}
			},
			{
				// Placement Analytics
				path: "/analytics/placement/:placementId",
				name: "placementanalytics",
				component: () => import("@/views/PlacementAnalytics.vue"),
				meta: {
					requiresAuth: true,
					title: "Placement Analytics"
				}
			},
			{
				// Campaign Analytics
				path: "/analytics/campaign/:campaignId",
				name: "campaignanalytics",
				component: () => import("@/views/CampaignAnalytics.vue"),
				meta: {
					requiresAuth: true,
					title: "Campaign Analytics"
				}
			},
			{
				// Cretive page
				path: "/creatives/:campaignId",
				component: () => import("@/views/CreativesPage.vue"),
				meta: {
					requiresAuth: true,
					title: "Creatives"
				},
			},
			{
				// Placement page
				path: "/placements/:campaignId",
				name: "placements",
				component: () => import("@/views/PlacementPage.vue"),
				meta: {
					requiresAuth: true,
					title: "Placements"
				},
			},
			{
				// Placement details page
				path: "/placements/details/:placementId",
				name: "placement-details",
				component: () => import("@/views/PlacementDetailsPage.vue"),
				props: true,
				meta: {
					requiresAuth: true,
					title: "Placement Details"
				},
			},

			// ALl Creatives page
			{
				// Placement page
				path: "/creatives",
				component: () => import("@/views/AllCreatives.vue"),
				meta: {
					requiresAuth: true,
					title: "All Creatives"
				},
			},


		],
	},

	{
		path:"/edit-brand-kit/:editId",
		name:"Edit Brand kit",
		component: () => import("@/layouts/SharedBrandKitLayout.vue"),
		props:true,
		meta:{
			title:"Edit Brand kit",
			requiresAuth: false
		}
	},


	{
		path:"/edit-brand-kit/sub-folder/:folderId/:editId",
		name:"Edit Brand kit Sub Folder",
		component: () => import("@/views/SharedBrandkitSubFolder.vue"),
		props:true,
		meta:{
			title:"Edit Brand kit Sub Folder",
			requiresAuth: false
		}
	},

	{
		path:"/preview-brand-kit/:editId",
		name:"Preview Brand kit",
		component: () => import("@/layouts/SharedBrandKitLayout.vue"),
		props:true,
		meta:{
			title:"Preview Brand kit",
			requiresAuth: false
		}
	},

	{
		path:"/preview-brand-kit/sub-folder/:folderId/:editId",
		name:"Preview Brand kit Sub Folder",
		component: () => import("@/views/SharedBrandkitSubFolder.vue"),
		props:true,
		meta:{
			title:"Preview Brand kit Sub Folder",
			requiresAuth: false
		}
	},


	{
		path: "/analytics",
		component: () => import("@/layouts/Dashboard.vue"),
		children: [
		]
	},
	{
		// Public Preview
		path: "/preview/:creativeid",
		name: "preview",
		component: () => import("@/views/Public_views/Preview.vue"),
		props: true,
		meta: {
			title: "Preview",
			requiresAuth: false
		}
	},
	{
		// Template Preview
		path: "/template-preview/:templateUniqueId",
		name: "Template preview",
		component: () => import("@/views/Public_views/Preview.vue"),
		props: true,
		meta: {
			title: "Template Preview",
			requiresAuth: false
		}
	},
	{
		// Editor
		path: "/editor/:creativeid",
		component: () => import("@/layouts/IDE.vue"),
		name: "IDELayout",
		meta: {
			requiresAuth: true,
			title: "Editor"
		}
	},
	{
		// Mimic User for Admin
		path: "/mimic-user",
		component: () => import("@/views/MimicUser.vue"),
	},
	{
		// sub organization impersonation
		path : "/impersonate-tenant",
		name: "ImpersonateTenant",
		component: () => import("@/views/ImpersonateTenant.vue"),
	},
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: () => import("@/views/NotFound.vue"),
		meta: {
			title: "404"
		}
	}
];

export default routes;
